import React from "react";

/**
 * Pulse Loader Component
 * Modern, subtle loading states with pulsing animations
 */
const PulseLoader = ({
  size = "default", // "small", "default", "large"
  variant = "default", // "default", "dots", "rings", "bars"
  color = "emerald", // "emerald", "blue", "purple", "orange"
  className = "",
  count = 3
}) => {
  // Size configurations
  const sizeConfig = {
    small: {
      dot: "w-1.5 h-1.5",
      ring: "w-3 h-3",
      bar: "w-1 h-3",
      gap: "gap-1"
    },
    default: {
      dot: "w-2 h-2",
      ring: "w-4 h-4",
      bar: "w-1.5 h-4",
      gap: "gap-1.5"
    },
    large: {
      dot: "w-3 h-3",
      ring: "w-6 h-6",
      bar: "w-2 h-6",
      gap: "gap-2"
    }
  };

  const config = sizeConfig[size];

  // Color configurations
  const colorConfig = {
    emerald: "bg-emerald-500",
            blue: "bg-emerald-500",
    purple: "bg-purple-500",
    orange: "bg-orange-500"
  };

  const colorClass = colorConfig[color];

  // Variant renderers
  const renderDots = () => (
    <div className={`flex items-center ${config.gap}`}>
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className={`${config.dot} ${colorClass} rounded-full animate-pulse`}
          style={{
            animationDelay: `${index * 0.2}s`,
            animationDuration: '1.4s'
          }}
        ></div>
      ))}
    </div>
  );

  const renderRings = () => (
    <div className={`flex items-center ${config.gap}`}>
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className={`${config.ring} ${colorClass} rounded-full animate-ping opacity-75`}
          style={{
            animationDelay: `${index * 0.3}s`,
            animationDuration: '1.5s'
          }}
        ></div>
      ))}
    </div>
  );

  const renderBars = () => (
    <div className={`flex items-end ${config.gap}`}>
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className={`${config.bar} ${colorClass} rounded-full animate-pulse`}
          style={{
            animationDelay: `${index * 0.15}s`,
            animationDuration: '1.2s'
          }}
        ></div>
      ))}
    </div>
  );

  // Render based on variant
  const renderLoader = () => {
    switch (variant) {
      case "dots":
        return renderDots();
      case "rings":
        return renderRings();
      case "bars":
        return renderBars();
      default:
        return renderDots();
    }
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      {renderLoader()}
    </div>
  );
};

export default PulseLoader;
